import * as React from "react";
import {Alert, Spinner, Form, Button, Accordion, Card, Modal, Row, Col} from "react-bootstrap";
import withRequestState from "../../components/WithRequestState";
import {connect} from "react-redux";
import { RequestStateProps } from "../../interfaces/RequestState";
import {getEquipment, createEquiment, CREATE_EQUIPMENT_REQUEST, GET_EQUIPMENT_REQUEST} from "../../redux/equipment/actions";
import { Equipment } from "../../interfaces/Equipment";
import { State } from "../../interfaces/State";
import {Formik} from "formik";
import QRCode from "qrcode.react";
import SideBar from "../../components/SideBar/Sidebar";
import { withRouter, RouteComponentProps} from "react-router-dom";
import { isSuccessful } from "../../redux/requests/selectors";
import {resetRequestState} from "../../redux/requests/action";
import "./index.scss";

interface IProps {
    getEquipment: () => void;
    createEquiment: (type : string, sideId : string) => void;
    equipment: Equipment[];
    success: boolean;
    resetRequestState: (types : string[]) => void;
}

interface IState {
    createEquiment: boolean;
}

class EquipmentPage extends React.Component<IProps & RequestStateProps & RouteComponentProps, IState> {

    get equipment() : Equipment[] {
        const {match: {params}} = this.props;
        if ((params as any).siteId){
            return this.props.equipment
            .filter(equipment => equipment.siteId == (params as any).siteId);
        } else {
            return this.props.equipment;
        }
    }

    get siteId() : string {
        const {match: {params}} = this.props;
        return (params as any).siteId;
    }

    constructor(props){
        super(props);
        this.state = {
            createEquiment: false
        }
    }

    componentWillUnmount(){
        this.props.resetRequestState([CREATE_EQUIPMENT_REQUEST]);
    }

    componentDidUpdate(){
        if (this.props.success && this.state.createEquiment){
            this.setState({createEquiment: false});
        }
    }
    
    componentDidMount(){
        if (this.props.equipment.length == 0) {
            this.props.getEquipment();
        }
    }

    goBack(){
        this.props.history.goBack();
    }    

    render(){
        return (
            <div id="equipment-page">
                <div className="top-banner p-4">
                    <h3>Equipment</h3>
                </div>
                <div className="p-4">                

                    <h4>Equipment list</h4>
                    <p>Something bla bla bla</p>

                    <Row>
                        <Col md={2}>
                            <Form.Group>
                                <Form.Label>Search equipment</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="search"
                                />    
                            </Form.Group>                        
                        </Col>
                        <Col />
                        <Col md={3}>
                            <div className="d-flex align-items-center">
                                <Button className="toggle-button mx-1">On site</Button>
                                <Button className="toggle-button mx-1">Off site</Button>
                                <Button className="toggle-button mx-1">Filter</Button>
                                <Button className="toggle-button mx-1">Bulk action</Button>
                            </div>                  
                        </Col>
                    </Row>

                    <div className="my-4">                    

                        {
                            this.props.isPending ? 
                                <Spinner animation="border" /> :
                                <div>
                                    <div className="list">
                                        <Row className="list-header mt-3 p-3" noGutters>
                                            <Col md={1} xs={1}>#</Col>
                                            <Col>Equipment title</Col>
                                            <Col>Equipment ID</Col>
                                            <Col>Type</Col>
                                            <Col>Project</Col>
                                            <Col>Contactor</Col>
                                            <Col>Status</Col>
                                            <Col>Last updated</Col>
                                            <Col md={1}>Details</Col>
                                        </Row>
                                        <div>
                                            {
                                                this.props.equipment.map((equipment, index) => (
                                                    <Row className="list-item" key={index} noGutters>
                                                        <Col md={1} xs={1}>
                                                            {index+1}
                                                        </Col>
                                                        <Col>
                                                            {equipment.name}
                                                        </Col>
                                                        <Col>
                                                            {equipment.code}
                                                        </Col>
                                                        <Col>
                                                            Excavactor
                                                        </Col>
                                                        <Col>None</Col>
                                                        <Col>None</Col>
                                                        <Col>Unknown</Col>
                                                        <Col>Last updated</Col>
                                                        <Col md={1} xs={1} className="text-right">
                                                            <i className="material-icons">
                                                                chevron_right
                                                            </i>
                                                        </Col>
                                                    </Row>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                        }

                    </div>

                    <Button onClick={() => this.setState({createEquiment: true})}>Add new Equipment</Button>
                    <Modal
                        show={this.state.createEquiment}
                        centered
                    >
                        <Modal.Header>
                            <Modal.Title>New Equipment</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Formik
                                initialValues={{
                                    type: "",
                                    siteId: this.siteId
                                }}
                                onSubmit={({type, siteId}) => {
                                    this.props.createEquiment(type, siteId);
                                }}
                            >
                                {(props) => (
                                    <Form onSubmit={props.handleSubmit}>
                                        <Form.Group>
                                            <Form.Label>
                                                Equipment name
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={props.values.type}
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                name="type"
                                            />
                                        </Form.Group>

                                        <Form.Group>
                                            <Form.Label>
                                                Site id
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={props.values.siteId}
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                name="siteId"
                                            />
                                        </Form.Group>


                                        <Row>
                                            <Col xs={12} md={6}>
                                                {
                                                    this.props.isPending ? 
                                                        <div className="d-flex align-items-center">
                                                            <Spinner animation="border" />
                                                            Loading...
                                                        </div> :
                                                        <Button type="submit" variant="primary" className="w-100">
                                                            Submit
                                                        </Button>
                                                }
                                            </Col>
                                            <Col xs={12} md={6} className="text-right order-12">
                                                <Button variant="outline-primary" className="w-100" onClick={() => this.setState({createEquiment: false})}>Close</Button>
                                            </Col>
                                        </Row>                                        
                                    </Form>
                                )}
                            </Formik>
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        )
    }

}


export default withRouter(connect((state : State) => ({
    equipment: state.equipment,
    success: isSuccessful(state, [CREATE_EQUIPMENT_REQUEST])
}), ({
    getEquipment,
    createEquiment,
    resetRequestState
}))(withRequestState(EquipmentPage, [GET_EQUIPMENT_REQUEST, CREATE_EQUIPMENT_REQUEST])));